export default __webpack_public_path__ + "2a3e1018264bafa4cf01eb1d8e79b7ca.svg";